import { NavController, ToastController } from 'ionic-angular';
import { Component } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl, AbstractControl } from '@angular/forms';

import { DataService } from '../../services/data';
import { LoadingController } from 'ionic-angular';

@Component({
    selector: 'page-forgot-password',
    templateUrl: 'forgot-password.html'
})
export class ForgotPasswordPage {
    emailAddress: string = '';

    resetForm: FormGroup;
    validationMessages: any[];

    passwordType: string = 'password';
    passwordIconType: string = 'eye';

    resettingPassword: boolean;

    constructor(public nav: NavController, private toastController: ToastController, private data: DataService, 
                private loadingControl: LoadingController, private formBuilder: FormBuilder) {
        this.resetForm = this.formBuilder.group({
            password: new FormControl('password',  Validators.required),
            confirmPassword: new FormControl('confirm',  this.checkPasswords),
        });
            
        this.validationMessages = [
            { name: 'password', type: 'required', message: 'Password is required.' },
            { name: 'confirmPassword', type: 'checkPasswords', message: 'Passwords do not match.' },
        ];
    }

    checkPasswords(control: AbstractControl) {
        if (!control || !control.parent) {
            return null;
        }

        const password = control.parent.get('password');
        const confirmPass = control.parent.get('confirmPassword');

        if (password == null || confirmPass == null) {
            return null;
        }

        return password.value === confirmPass.value && confirmPass.value != null && confirmPass.value != '' ? null : { checkPasswords: true};
    }

    showHide() {
        if (this.passwordType == 'text') {
            this.passwordType = 'password';
            this.passwordIconType = 'eye';
        }
        else {
            this.passwordType = 'text';
            this.passwordIconType = 'eye-off';
        }
    }

    forgotPassword() {
        if (this.resettingPassword)
            return;

        this.resettingPassword = true;
        let loading = this.loadingControl.create({
            content: 'Sending temporary password to ' + this.emailAddress + '...',
        });

        loading.present();

        this.data.sendTemporaryPassword(this.emailAddress)
        .then(data => {
            this.resettingPassword = false;
            loading.dismiss();
            
            this.toastController.create({
                message: 'Check your email for your temporary password and login to to reset your password.',
                duration: 3000,
                position: 'middle'

            }).present();

            this.nav.pop();
        }, error => {
            this.resettingPassword = false;
            loading.dismiss();
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/login/forgot-password.ts